import utils from 'utils';
import { store } from 'src/redux/store';

export default {
  getCoupon(data) {
    const { token } = store.getState();
    const headers = utils.getHeadersInToken(token);
    return this.http(
      'Lottery',
      'post',
      '/api/v1/coupons/receive_newbie_coupons',
      data,
      headers
    );
  },

  /**
   * 获取当前页面信息
   */
  getPageData() {
    const { token } = store.getState();
    const headers = utils.getHeadersInToken(token);
    return this.http(
      'Lottery',
      'get',
      '/api/v1/coupons/newbie_coupons',
      '',
      headers
    );
  }
};
